import { createAddAccountModal } from 'features/add-account';
import { createBlockAccountModal } from 'features/block-account';
import { createDeleteAccountModal } from 'features/delete-account';
import { createEditAccountModal } from 'features/edit-account';
import { createUnblockAccountModal } from 'features/unblock-account';
import { createAccountRegistry } from 'entities/account';
import { accountPageAccountsModel } from '../../model';
import cls from './account-page-accounts.module.scss';

const AccountRegistry = createAccountRegistry(accountPageAccountsModel.accountRegistryModel);

const AddAccountModal = createAddAccountModal(accountPageAccountsModel.addAccountModel);

const EditAccountModal = createEditAccountModal(accountPageAccountsModel.editAccountModel);

const DeleteAccountModal = createDeleteAccountModal(accountPageAccountsModel.deleteAccountModel);

const BlockAccountModal = createBlockAccountModal(accountPageAccountsModel.blockAccountModel);

const UnblockAccountModal = createUnblockAccountModal(accountPageAccountsModel.unblockAccountModel);

export const AccountPageAccounts = () => (
	<>
		<AccountRegistry
			className={cls.accountPageAccountsRegistry}
			withParent={false}
			withTitle={false}
			topBarActionSlot={<AddAccountModal.Button />}
			tableTdActionSlot={(account) => (
				<div className={cls.accountPageAccountsActions}>
					<EditAccountModal.ActionIcon modalData={account} />
					{account.isLocked ? (
						<UnblockAccountModal.ActionIcon modalData={account} />
					) : (
						<BlockAccountModal.ActionIcon modalData={account} />
					)}
					<DeleteAccountModal.ActionIcon modalData={account} />
				</div>
			)}
			emptyActionSlot={<AddAccountModal.Button />}
		/>
		<AddAccountModal />
		<EditAccountModal />
		<DeleteAccountModal />
		<BlockAccountModal />
		<UnblockAccountModal />
	</>
);
